// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import {perr, perr_www_visit} from 'hola_pub_util';
import {useContext, useEffect} from 'react';
// @ts-ignore
import {App_context} from '../context.js';
// @ts-ignore
import {ext} from '/www/hola/pub/be.js';

interface i_use_page_visit_props {
    page: string;
    perr_opt?: ()=>object_of<any>;
    track_inited?: boolean;
}

export const use_page_visit = (props:i_use_page_visit_props)=>{
    const {page, perr_opt = ()=>({}), track_inited} = props;
    const {inited, user, svc_info} = useContext(App_context);
    useEffect(()=>{
        perr_www_visit({id: `www_${page}_visit`, user, ...perr_opt()});
    }, []);
    useEffect(()=>{
        if (inited && track_inited)
        {
            const ext_ver = ext()?.ver;
            const svc_appid = svc_info.appid;
            perr({id: `www_${page}_visit_inited`, user, ...perr_opt(),
                build: {ext_ver, svc_appid}});
        }
    }, [inited]);
};
